/**
 * @generated SignedSource<<28db810c424143f6be9b3e6c8eaa9cce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useOneBuyPageTemplateAbTestHelper_buyPage$data = {
  readonly seoAbTestV2List: ReadonlyArray<{
    readonly config: {
      readonly testName: string | null;
    } | null;
    readonly variant: string | null;
  } | null> | null;
  readonly totalResults: number | null;
  readonly " $fragmentType": "useOneBuyPageTemplateAbTestHelper_buyPage";
};
export type useOneBuyPageTemplateAbTestHelper_buyPage$key = {
  readonly " $data"?: useOneBuyPageTemplateAbTestHelper_buyPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"useOneBuyPageTemplateAbTestHelper_buyPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useOneBuyPageTemplateAbTestHelper_buyPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AbTestConfigV2UserVariant",
      "kind": "LinkedField",
      "name": "seoAbTestV2List",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "variant",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AbTestConfigV2",
          "kind": "LinkedField",
          "name": "config",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "testName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalResults",
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "417f6b2403272ca431a01d5872f40875";

export default node;
